import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';
import './ChromosomeSwiper.css';
import 'swiper/css';
import 'swiper/css/bundle';
import 'swiper/css/pagination';
import pc1 from './images/pc1.jpg';
import pc2 from './images/pc2.jpg';
import pc3 from './images/pc3.jpg';


const ChromosomeSwiper = () => {
  return (
    <div className="swiper">
      <Swiper
        modules={[Navigation, Pagination, Scrollbar]}
        spaceBetween={500}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
      >
        <SwiperSlide>
          <img className="chromosome-image" src={pc1} alt=""></img>
        </SwiperSlide>
        <SwiperSlide>
          <img className="chromosome-image" src="https://cdn.pixabay.com/photo/2013/07/18/10/59/dna-163710_1280.jpg" alt=""></img>
        </SwiperSlide>
        <SwiperSlide>
          <img className="chromosome-image" src={pc2} alt=""></img>
        </SwiperSlide>
        <SwiperSlide>
          <img className="chromosome-image" src={pc3} alt=""></img>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}

export default ChromosomeSwiper;